export function isBot(userAgent) {
    const botNameTest = /.+(bot|spider|crawler|slurp).+/i
    return botNameTest.test(userAgent)
}
